var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MainLayout',[_c('section',{staticClass:"grid grid-cols-2 gap-4"},[_c('div',[_c('EditProfile'),_c('EditPassword')],1),_c('div',[_c('MFA'),_c('WebAuthn')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }